module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "title2"
  }, [_vm._v("请上传机器码文件TXT")]), _vm._v(" "), _c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "action": "",
      "on-change": _vm.handleChange,
      "auto-upload": false,
      "limit": 1
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("上传文件")])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "title"
  }, [_vm._v("UploadMachine")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d1c5743c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UploadMachineCode.vue
// module id = 745
// module chunks = 1